@if (favorite) {
  <div class="favorite-wrapper">
    <div class="top-line">
      <button class="ui small labeled icon button"
            [ngClass]="{
               orange: favorite.status === eFavoriteStatus.Planned,
               olive: favorite.status === eFavoriteStatus.Watched,
               blue: favorite.status === eFavoriteStatus.Watching,
               brown: favorite.status === eFavoriteStatus.OnHold,
               grey: favorite.status === eFavoriteStatus.Dropped,
               inverted: isDarkTheme
               }"
        (click)="editReview()">
        <i class="bookmark icon"></i>{{eFavoriteLabel[favorite.status]}}</button>
        @if (item.subItems && item.subItems.length > 0) {
          <form class="progress" [formGroup]="favProgressForm" (submit)="updateProgress()">
            <div>我的进度：</div>
            <div class="ui small input">
              <input type="number" min="0" [max]="epCount" formControlName="epFavCount">
            </div>
            <div class="progress-divider">/</div>
            <div class="total-ep">{{epCount}}</div>
            <button class="ui small button update-button" type="submit" [disabled]="!favProgressForm.dirty || favProgressForm.invalid">更新</button>
          </form>
        }
        <div class="bgm-sync-control">
          <button class="ui small basic labeled icon button"
                  type="button"
                  [ngClass]="{loading: bgmSyncSubmitting() || bgmSyncPolling()}"
                  [disabled]="bgmSyncSubmitting() || bgmSyncActive() || bgmSyncReauthorizationRequired()"
                  (click)="syncFavoriteToBgm()">
            <i class="sync alternate icon"></i>同步到 bgm.tv
          </button>
          @if (bgmSyncStatus(); as status) {
            <div class="bgm-sync-status" [ngClass]="bgmSyncStatusClass()" role="status" aria-live="polite">
              <i class="icon" [ngClass]="bgmSyncIconClass()"></i>
              <span>{{bgmSyncStateLabel()}}</span>
              @if (bgmSyncOperationLabel()) {
                <span class="operation">{{bgmSyncOperationLabel()}}</span>
              }
              @if (status.attemptCount > 1) {
                <span class="attempt">第 {{status.attemptCount}} 次尝试</span>
              }
              @if (status.state === 'RetryScheduled') {
                <span class="retry-time">{{status.runAfter | date:'shortTime'}} 重试</span>
              }
              @if (status.message) {
                <span class="message">{{status.message}}</span>
              }
            </div>
          }
          @if (bgmSyncReauthorizationRequired()) {
            <a class="bgm-reauthorize" [routerLink]="['/settings/bgm']">重新连接 bgm.tv</a>
          }
        </div>
      </div>
      <div class="section-header">我的评价</div>
      @if (favorite) {
        <app-my-review [comment]="favorite.reviewComment" [rating]="favorite.rating" (editReview)="editReview()"></app-my-review>
      }
    </div>
  }
  @if (!favorite) {
    <div class="favorite-wrapper">
      <button class="small ui basic button"
        [ngClass]="{inverted: isDarkTheme}"
        (click)="editReview()"><i class="remove bookmark icon"></i> 收藏
      </button>
    </div>
  }
